/**
 * Header strip for the auth (login / signup / forgot-password) layout.
 * Renders the brand logo only — no navigation, no user controls.
 *
 * Uses a real `<header>` element (was a `<div>`) so screen readers
 * announce the landmark correctly.
 */
const AuthHeader = () => {
  return (
    <header>
      <img
        src="/icons/Primary.svg"
        alt="Simpld logo"
        className="xl:w-[250px] w-[150px] xl:h-[70px]"
      />
    </header>
  );
};

export default AuthHeader;
